import { Box, CircularProgress, Typography } from '@mui/material';

export default function CarregamentoRota() {
    return (
        <Box
            role="status"
            aria-live="polite"
            sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                textAlign: 'center',
                pointerEvents: 'none',
            }}
        >
            <Box
                aria-hidden="true"
                sx={{
                    width: 48,
                    height: 48,
                    display: 'grid',
                    placeItems: 'center',
                    color: 'primary.main',
                }}
            >
                <CircularProgress
                    size={32}
                    thickness={3}
                    color="primary"
                    sx={{
                        '@media (prefers-reduced-motion: reduce)': {
                            animation: 'none',
                            '& .MuiCircularProgress-circle': { animation: 'none' },
                        },
                    }}
                />
            </Box>
            <Typography sx={{ color: 'text.secondary', fontSize: 14, fontWeight: 400 }} aria-hidden="true">
                Carregando…
            </Typography>
        </Box>
    );
}
